import React from "react";
import Hero from "./components/Hero";
import About from "./components/About";
import Logos from "./components/Logos";
import Grid from "./components/Grid";
import Footer from "./components/Footer";
import AboutPage from './components/AboutPage'; // Your AboutPage component
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // Import FontAwesome Icon
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'; // Icons for down and up arrows
import "./styles/App.css";

const App = () => {

  const scrollToAbout = () => {
    setTimeout(() => {
      const aboutSection = document.getElementById("AboutPage");
      if (aboutSection) {
        aboutSection.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 100); // Small delay ensures the element exists
  };
  

  return (
    <div className="App">
      <Hero scrollToAbout={scrollToAbout} /> {/* Pass scrollToAbout as a prop */}
      <About />
      <Logos />
      <Grid />
      <AboutPage />
      <Footer />
    </div>
  );
};

export default App;
